var exports = {
  "k": "xe564cbfb--fe7fec--container",
};

module.exports = exports;
